exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".custom-dropdown-menu-item {\n  position: relative;\n  left: -9px;\n  color: #606A80;\n  font-size: 13px; }\n  .custom-dropdown-menu-item i {\n    margin-right: 7px; }\n  .custom-dropdown-menu-item .hide-check {\n    visibility: hidden; }\n  .custom-dropdown-menu-item .active {\n    color: #364159;\n    font-weight: normal; }\n", ""]);

